import { createSlice } from '@reduxjs/toolkit';

// localStorage에서 token 불러오기
const loadTokenFromStorage = () => {
  try {
    const token = localStorage.getItem('token');
    return token ? token : null;
  } catch (error) {
    return null;
  }
};

const initialState = {
  token: loadTokenFromStorage(),
  isAuthenticated: !!loadTokenFromStorage(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
      state.isAuthenticated = true;
      // localStorage에 저장
      localStorage.setItem('token', action.payload);
    },
    clearToken: (state) => {
      state.token = null;
      state.isAuthenticated = false;
      // localStorage에서 제거
      localStorage.removeItem('token');
    },
  },
});

export const { setToken, clearToken } = authSlice.actions;
export default authSlice.reducer;

